import React from 'react';
import BadgeBase, { TBadge } from './BadgeBase';
import { BadgeSignals } from '../../types/TEBadgeSignal';

const Success = (props: Omit<TBadge, 'signal'>) => <BadgeBase {...props} signal={BadgeSignals.Success} />;

export default Success;
